import { DateTime } from 'luxon';

export const dateToDbDateString = (date: Date) => {
    return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
};

export const dateToDbDateStringWithTimeZone = (date: Date) => {
    return date.toISOString();
};

export const dateToDbMonthDateString = (date: Date) => {
    return DateTime.fromJSDate(date).toFormat('yyyy-MM');
};

export const dateToUiDateTimeString = (date: Date) => {
    return DateTime.fromJSDate(date).toFormat('dd.MM.yyyy HH:mm:ss');
};

export const dateAndTimeToDbDateTimeString = (date: Date, time: Date) => {
    const d = new Date(time);
    d.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    return d.toISOString();
};

/**
 * Gets UTC beginning time of day from local beginning time of day.
 * @param date
 */
export const getUtcDate = (date: Date): Date => {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
};

/**
 * Gets local beginning time of day from date.
 * @param timestamp
 */
export const getDate = (timestamp: Date): Date => {
    return new Date(timestamp.getFullYear(), timestamp.getMonth(), timestamp.getDate());
};

/**
 * Gets local beginning time of day from UTC beginning time of day.
 * @param date
 */
export const getLocalDate = (date: Date): Date => {
    return new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
};

export const underscoreToCamel = (str: string) => {
    return str.replace(/(_[a-z0-9])/g, (s) => s.toUpperCase().replace(/_/g, ''));
};

export const hyphenatedToCamel = (str: string) => {
    return str.replace(/(-[a-z0-9])/g, (s) => s.toUpperCase().replace(/-/g, ''));
};

export const camelToUnderscore = (str: string) => {
    return str[0].toLocaleLowerCase() + str.substring(1).replace(/([A-Z])/g, (s) => '_' + s.toLowerCase());
};

export const camelToHyphenated = (str: string) => {
    return str[0].toLocaleLowerCase() + str.substring(1).replace(/([A-Z])/g, (s) => '-' + s.toLowerCase());
};

export const underscoreToHyphenated = (str: string) => {
    return str.toLowerCase().replace(/_/g, '-');
};

export const lowerCamelToUpperCamel = (str: string) => {
    return str.charAt(0).toUpperCase() + str.substring(1);
};

export const upperCamelToLowerCamel = (str: string) => {
    return str.charAt(0).toLowerCase() + str.substring(1);
};

export const spacesToHyphenated = (str: string) => {
    return str.toLowerCase().replace(/ /g, '-');
};

export const spacesToUnderscore = (str: string) => {
    return str.toLowerCase().replace(/ /g, '_');
};

export const dateDifferenceToString = (laterDate: Date, earlierDate: Date) => {
    const laterTimeMillis = laterDate.getTime();
    const earlierTimeMillis = earlierDate.getTime();

    // get total seconds between the times
    let delta = Math.abs(laterTimeMillis - earlierTimeMillis) / 1000;

    // calculate (and subtract) whole days
    const days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // calculate (and subtract) whole hours
    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    // calculate (and subtract) whole minutes
    const minutes = Math.floor(delta / 60) % 60;

    return `${days}d ${hours}h ${minutes}min`;
};

export const dateDifferenceInEntireDays = (laterDate: Date, earlierDate: Date): number => {
    const laterTimeMillis = laterDate.getTime();
    const earlierTimeMillis = earlierDate.getTime();

    // get total seconds between the times
    const delta = Math.abs(laterTimeMillis - earlierTimeMillis) / 1000;

    // calculate (and subtract) whole days
    return Math.floor(delta / 86400);
};

export const getEnumerationValueLabelKey = (enumName: string, key: string) => {
    return 'enum.' + upperCamelToLowerCamel(enumName) + '.' + underscoreToCamel(key.toLowerCase());
};
